"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.function.name.js");
var getters = {
  sidebar: function sidebar(state) {
    return state.app.sidebar;
  },
  size: function size(state) {
    return state.app.size;
  },
  device: function device(state) {
    return state.app.device;
  },
  visitedViews: function visitedViews(state) {
    return state.tagsView.visitedViews;
  },
  cachedViews: function cachedViews(state) {
    return state.tagsView.cachedViews;
  },
  token: function token(state) {
    return state.user.token;
  },
  avatar: function avatar(state) {
    return state.user.avatar;
  },
  name: function name(state) {
    return state.user.name;
  },
  email: function email(state) {
    return state.user.email;
  },
  introduction: function introduction(state) {
    return state.user.introduction;
  },
  roles: function roles(state) {
    return state.user.roles;
  },
  permission_routes: function permission_routes(state) {
    return state.permission.routes;
  },
  errorLogs: function errorLogs(state) {
    return state.errorLog.logs;
  },
  countries: function countries(state) {
    return state.facets.countries;
  },
  genders: function genders(state) {
    return state.facets.genders;
  },
  expiryTime: function expiryTime(state) {
    return state.user.expiryTime;
  },
  uuid: function uuid(state) {
    return state.user.uuid;
  },
  userMetadata: function userMetadata(state) {
    return state.user.metadata;
  },
  coachTools: function coachTools(stage) {
    return stage.facets.coachTools;
  },
  givenName: function givenName(state) {
    return state.user.givenName;
  },
  familyName: function familyName(state) {
    return state.user.familyName;
  }
};
var _default = exports.default = getters;